import { CSSProperties, useMemo } from "react";
import SocialProfilePic from "./SocialProfilePic";
import { useTheme } from "../../../hooks/useTheme";
import { useSelector } from "react-redux";
import { getAccountSlice } from "../../../redux/slices/accountSlice";
import { DMAutomationPlatform } from "@markit/common.types";
import { facebookPageAsProfilePicAccount } from "../../../utils/facebookApiUtils";

type SocialProfilePicsLabelProps = {
  igAccountIds: string[];
  platform: DMAutomationPlatform;
  textStyles?: CSSProperties;
};

// Displays the social profile pics and a label for the accounts
const SocialProfilePicsLabel = (props: SocialProfilePicsLabelProps) => {
  const { igAccountIds, platform, textStyles } = props;
  const { instagramAccounts, facebookPages } = useSelector(getAccountSlice);
  const { theme } = useTheme();

  const isFacebook = useMemo(
    () => platform === DMAutomationPlatform.FACEBOOK,
    [platform]
  );

  const totalConnectedCount = useMemo(
    () => (isFacebook ? facebookPages.length : instagramAccounts.length),
    [isFacebook, facebookPages.length, instagramAccounts.length]
  );

  const socialAccounts = useMemo(
    () =>
      isFacebook
        ? facebookPages
            .filter((page) => igAccountIds.includes(page.id))
            .map(facebookPageAsProfilePicAccount)
        : instagramAccounts.filter((account) =>
            igAccountIds.includes(account.id)
          ),
    [isFacebook, instagramAccounts, facebookPages, igAccountIds]
  );

  return (
    <>
      <div className="AlignedRow">
        {socialAccounts.map((account, index) => (
          <div
            key={account.id}
            style={{ marginLeft: index === 0 ? 0 : -10, flexShrink: 0 }}
          >
            <SocialProfilePic
              account={account}
              size={20}
              borderStyle={`1.5px solid ${theme.SecondaryBG.backgroundColor}`}
            />
          </div>
        ))}
      </div>
      <span
        className="smallBodySubtext TextOverflowEllipsis"
        style={textStyles}
      >
        {socialAccounts.length === 0
          ? "No Connected Account"
          : socialAccounts.length === 1
            ? `@${socialAccounts[0].username}`
            : socialAccounts.length === totalConnectedCount
              ? `All ${totalConnectedCount} accounts`
              : `${socialAccounts.length} accounts`}
      </span>
    </>
  );
};

export default SocialProfilePicsLabel;
